<template>
  <div class="weizhan">
    <div class="weizhanHeader">
      <div style="height: 2rem"></div>
      <div class="info_userinfo">
        <div class="user_head">
          <img :src="data.user_info.avatar" />
        </div>
        <div class="user_name">{{ data.user_info.nickname }}</div>
        <div class="user_tag">
          <span v-for="item in data.cate_list">{{ item }}</span>
        </div>
        <div class="user_qianming">
          {{ data.user_info.personality }}
        </div>
        <!-- <div class="datas">
          <span
            >联系方式:{{
              data.user_info.phone ? "暂未提供" : data.user_info.phone
            }}</span
          >
        </div> -->
      </div>
    </div>
    <!-- <div class="weizhanMain">
      <div class="weizhanTag">
        <div class="tagTitle">
          <label>好友印象</label><span>+添加印象</span>
        </div>
        <div class="tags">
          <span>你好</span>
          <span>值得信任</span>
          <span>专业</span>
          <span>人很赞</span>
          <span>优秀人才</span>
        </div>
      </div>
    </div> -->
    <div style="height: 0.24rem; background-color: #f0f0f0"></div>
    <div class="weizhanMain">
      <div class="weizhanTag">
        <div class="tagTitle">
          <label>我的资讯</label>
          <!-- <router-link :to="{ path: '/jiaodian/userWeizhan_zixun' }"
            >更多</router-link
          > -->
        </div>
        <div class="newlist">
          <ul class="list1">
            <li
              v-for="(item, index) in cidList"
              @click="gopageinfo(item.secret_key, item.id)"
            >
              <div class="li_l">
                <div class="li_title">{{ item.title }}</div>
              </div>
              <div class="li_r">
                <img :src="item.image_input[0]" class="li_img " />
                <!-- <div>引流{{ item.visit ? item.visit : 0 }}次</div> -->
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="weizhanMain">
      <div class="weizhanTag">
        <div class="tagTitle"><label>我的项目</label></div>
        <div class="newlist">
          <ul class="list2">
            <li
              v-for="(item, index) in projectList"
              :key="index"
              @click="goInfo(item.id)"
            >
              <div class="li_l2">
                <div class="li_title">{{ item.title }}</div>
                <div class="li_dec">{{ item.describe }}</div>
                <div class="li_tag">
                  <span
                    v-for="(item2, index2) in item.cate_name"
                    :key="index2"
                    >{{ item2 }}</span
                  >
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div style="height: .8rem;"></div>
  </div>
</template>

<script>
import "@assets/css/weizhan.css";
import "@assets/css/newlist2.css";
import { getHomeData, getShare, follow, getUserInfo } from "@api/public";
import cookie from "@utils/store/cookie";
import { getUser } from "@api/user";
import { openShareAll, wxShowLocation } from "@libs/wechat";
import { isWeixin } from "@utils/index";
// import newlist from "@components/newlist";
// import { goShopDetail } from "@libs/order";
const HAS_COUPON_WINDOW = "has_coupon_window";
const LONGITUDE = "user_longitude";
const LATITUDE = "user_latitude";
const MAPKEY = "mapKey";
let vm = null;
export default {
  name: "Index",
  components: {
    // newlist
  },
  props: {},
  data: function() {
    return {
      uid: "",
      key: "",
      data: {},
      cidList: [], //行业cid对应的列表
      projectList: [],
      shareBtn: true,
      changeBtn: false,
      showQianDialog: false,
      setphoneDialog: false,
      zixunDialog: false,
      newGoodsBananr: "",
      isWeixin: isWeixin(),
      followUrl: "",
      userMyUid: "", //获取用户自己的uid
      ismyTrue: false
    };
  },
  created() {
    vm = this;
  },
  mounted: function() {
    vm.setOpenShare();
    let that = this;
    this.key = this.$route.query.key;
    this.uid = this.$route.query.uid;
    that.getUser();
  },
  methods: {
    getUser() {
      getUser().then(res => {
        this.userMyUid = res.data.uid;
        this.getUserInfo();
      });
    },
    getUserInfo() {
      var that = this;
      if (that.key == "" || that.key == "undefined" || that.key == undefined) {
        that.key = "";
      }
      var data = "?uid=" + that.uid + "&secret_key=" + that.key;
      getUserInfo(data).then(res => {
        that.data = res.data;
        that.projectList = res.data.project_list;
        that.cidList = res.data.article_list;
        if (that.userMyUid == res.data.user_info.uid) {
          //表示这是我本人的微站
          that.ismyTrue = true;
        } else {
          that.ismyTrue = false;
        }
      });
    },
    gopageinfo(secret_key, id) {
      // window.location.href =
      //   "/jiaodian/imgtextDetail?key=" + secret_key + "&id=" + id;
      // window.location.href = "/jiaodian/imgtextDetail?id=" + id;
      if (this.ismyTrue) {
        window.location.href = "/jiaodian/imgtextDetail?id=" + id;
      } else {
        window.location.href =
          "/jiaodian/imgtextDetail?id=" + id + "&key=" + secret_key;
      }
    },
    goInfo(id) {
      window.location.href = "/project/info?projectid=" + id;
    },
    setOpenShare() {
      if (isWeixin()) {
        getShare().then(res => {
          var data = res.data.data;
          var configAppMessage = {
            desc: data.synopsis,
            title: data.title,
            link: "https://jdbeautycm.congwa.xyz",
            imgUrl: data.img
          };
          console.log("configAppMessage:", configAppMessage);
          openShareAll(configAppMessage);
        });
      }
    }
  }
};
</script>

<style>
.list2 {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.list2 li {
  box-shadow: 0 0 0.1rem #e2e2e2;
  padding: 0.3rem;
  border: none;
  margin-top: 0.15rem;
}
.li_l2 {
  width: 100%;
  margin: 0 auto 0.12rem;
}
.li_l2 .li_title {
  font-size: 0.3rem;
  color: #333;
  overflow: hidden;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
.li_l2 .li_dec {
  font-size: 0.25rem;
  color: #666;
  margin-top: 0.2rem;
  margin-bottom: 0.4rem;
  overflow: hidden;

  display: -webkit-box;

  -webkit-box-orient: vertical;

  -webkit-line-clamp: 2;
}
.li_l2 .li_tag {
  font-size: 0.22rem;
  color: #999;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
}
.li_l2 .li_tag span {
  margin-right: 0.12rem;
}
</style>
